var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer"},[_c('div',[_c('strong',[_vm._v("Copyright")]),_vm._v(" Locadados Data Solutions © 2008-"+_vm._s(new Date().getFullYear())+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }